export default {
  resetCheckoutToken:
    'We had to freshen up a few things. Try adding to your cart again!'
};



// WEBPACK FOOTER //
// ./src/constants/FlashMessages.js